// extracted by mini-css-extract-plugin
export default {"dynamicBoxBlock":"DynamicBoxControl_dynamicBoxBlock__tWvwE"};